<!-- @format -->
<!-- Migrated from AngularJS: profile.tpl.html -->

<div class="container student-profile">
  <div ui-view="title"></div>
  <div class="row">
    <div class="col-md-12">
      <div ui-view="secondaryNavigation"></div>
      <ui-view></ui-view>
    </div>
  </div>
</div>
